import { SELECIONAR_VALOR_DESCONTO_CALCULADO } from '../types';

export default function selecionarValorDescontoCalculado (descontoUsuarioCalculado) {
  return {
    type: SELECIONAR_VALOR_DESCONTO_CALCULADO,
    payload: descontoUsuarioCalculado
  }
}
